import { useEffect, useMemo, useState } from "react";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const useSportsPicks = (selectedDate: string) => {
    const [sportsPick, setSportsPick] = useState<any>(null);
    const [getSportsPicks, setGetSportsPicks] = useState<boolean>(false);

    useEffect(() => {
        const getSportsPicks = async () => {
            try {
                if (selectedDate == '') {
                    return;
                }
                const response = await fetch(`${API_ENDPOINT}/post/getSportsPick/${selectedDate}`);
                const res = await response.json();
                setSportsPick(res)
            } catch (error: any) {
                throw new error('Failed to get user info.');
            }
        };
        getSportsPicks();
    }, [selectedDate, getSportsPicks])

    const addNewSportsPicks = async (
        content: string,
        created_at: string
    ) => {
        try {
            const req = await fetch(`${API_ENDPOINT}/post/addSportsPick`, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    content: content,
                    created_at: created_at
                }),
            });
            if (req.status === 200) {
                const res = await req.json();
                setGetSportsPicks(!getSportsPicks)
                return res;
            } else {
                const res = await req.json();
                return res;
            }
        } catch (error) {
            throw new Error('Failed to add new Users.');
        }
    };

    return { sportsPick, addNewSportsPicks };
};
